import { Expose } from "class-transformer";

export class UpdateProjectHasWarehouseDto {
  @Expose()
  id: string;
}
